import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { of } from 'rxjs/internal/observable/of';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { throwError } from 'rxjs/internal/observable/throwError';

import { AuthService } from '../services/auth.service';
import { ToastService } from 'src/app/shared/utils/toast.service';

import { HttpStatusCode, SignOutReason } from '../constants/app.constant';
import { ConfirmDialogComponent } from '../dialog/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /***************Properties***************/
  private handledSessionExpiration: Boolean = false;
  /***************Properties***************/

  /*********************Constructor*********************/
  constructor(
    private authService: AuthService,
    private toast: ToastService,
    public dialog: MatDialog,
  ) {

  }
  /*********************Constructor*********************/

  /*********************Implementation Methods*********************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {}),
      catchError((error) => {
        if (this.handledSessionExpiration) {
          console.error('Session expired error:', error);
          return of(error);
        }

        if (error instanceof HttpErrorResponse) {
            console.error('[API error]:', request.url);
            console.error('[Status error]:', error.status);
            console.error('[Response error]:', error.error);
            /**Thiss tells 
            which api failed  
            401.403 issues
            Backend error
            ***/

          if (error.status === 403 && (error.headers.get('authreject') || error.headers.get('AuthReject') || error.headers.get('Authreject'))) {
              this.authService.logOut();
          }
          return throwError(error);
        }

        return throwError(error);
      })
    );
  }

}
